import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSingleUser = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 16.943A8.471 8.471 0 1 0 16 0a8.471 8.471 0 0 0 0 16.943zM15.93 32c6.148 0 11.488-2.978 14.178-8.064.154-.292-1.442-5.504-8.104-6.042-1.289-.104-3.39 1.658-6.074 1.658-2.197 0-4.32-1.822-5.83-1.658-6.198.668-8.466 5.837-8.197 6.324C4.64 29.15 9.895 32 15.93 32z" /></svg>;
export default SvgSingleUser;